
import { Section } from "./data-types";

export const AboutWhoWeAre: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Who We Are",
						content: () => [
							<p>
								The Geographical Society of Ireland is the professional organisation and representative body of
								geographers in Ireland and a recognised, consultative stakeholder for national policymaking.
								The GSI strives to promote the status and study of geography in Ireland and enhance its international reputation.
								The GSI aims to raise awareness of the value and impact of Geography in Ireland through a variety of activities,
								and actively lobbies government and other organisations on matters of strategic importance,
								including the status of the subject in the primary and secondary educational systems.
							</p>,
							// <p>
							// 	The Geographical Society of Ireland actively welcomes new members,
							// 	who may be Geography professionals and/or members of the public.
							// 	Information on membership is available <a href="https://www.geographicalsocietyireland.ie/membership.html">here</a>.
							// </p>,
							<p>
								The Geographical Society of Ireland actively welcomes new members.
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/1.jpg"
						},
					},
				}
			]
		}
	]
}
